import Inputmask from "inputmask"
export function mask(inputObject, number) {
  if (inputObject.selectionStart) {
    inputObject.setSelectionRange(number, number)
    inputObject.focus()
  }
  // danone regex
  // /^[0-9+]{1,}[0-9-()]{3,15}$/
  let mask = new Inputmask({ mask: "+38(999)999-9999", greedy: false})
  
  mask.mask(inputObject)
}
export function masking(name, $this) {
  let zero = 0
  let reg = /\d+/
  let events = ['click', 'focus', 'keyup']
  events.forEach(event => {
    let el = $this.$refs[name].$el || $this.$refs[name]
    if (!el) return 
    el.addEventListener(event, e => {
      const phone = document.getElementById('phone')
      if (phone) phone.dispatchEvent(new Event('input'))
      let numb = e.target.value.match(reg)
      if (numb) {
        mask(e.target, numb[zero].length)
      } else {
        mask(e.target, zero)
      }
    })

  })

}



/**
 * get cookie
 * @param {*} name 
 */
export function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([\.$?*|{}\(\)\[\]\\\/\+^])/g,
        "\\$1"
      )}=([^;]*)`
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}


/**
 * set cookie without expired date
 * @param {*} name 
 * @param {*} val 
 */
export function setCookie(name, val) {
  // if (this.getCookie(name) ) return
  
  let bake_cookie = (name, value) => {
    let now = new Date()
    let month = 12
    let days = 30
    now.setDate(month * days)
    let cookie = [name, '=', JSON.stringify(value), ';expires', '=', now.toUTCString(), '; path=/;'].join('')
    document.cookie = cookie
  }
  bake_cookie(name, val)
}


export function debounce(f, ms) {

  let isCooldown = false

  return function () {
    if (isCooldown) return

    f.apply(this, arguments)

    isCooldown = true

    setTimeout(() => isCooldown = false, ms)
  }

}

// Highlight the query part of the search term
const regexer = value => new RegExp(`(?![^&;]+;)(?!<[^<>]*)(${value})(?![^<>]*>)(?![^&;]+;)`, 'gi')

export function highlightTerm(value, term) {
  console.log(value, term);
  return value
    .replace(regexer(term),
      "<b style='color: #EE7325' >$1</b>")
}

export function findValueAndHighlightTerm(template, value, term) {
  return template
    .replace(regexer(value),
      highlightTerm(value, term))
}


// WEBPACK FOOTER //
// ./src/js/shared/utils/helpers.js